export default "data:image/svg+xml,hk.svg"